import { useQuery } from "react-query";
import axiosClient from "./../config/axiosClient";

const useCompaniesList = ({page=1, per_page=10}) => {
  return useQuery(
    ["companies-list", page],
    () => {
      return axiosClient
        .get("/issuer/companies", {params: {page, per_page}})
    }, {
      keepPreviousData: true,
    }
  );  
}

const useCompany = ({company_id}) => {
  return useQuery(
    ["company", company_id], 
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}`)
    }
  );  
}

const updateCompany = ({company_id, values}) => {
  return axiosClient.put(`/companies/${company_id}`, values);
}

const useTeamMembersList = ({company_id}) => {
  return useQuery(
    ["team-members-list", company_id],
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/team_members`)
    }
  );  
}

const createTeamMember = ({company_id, values}) => {
  return axiosClient.post(`/issuer/companies/${company_id}/team_members/`, values);
}

const updateTeamMember = ({company_id, team_member_id, values}) => {
  return axiosClient.put(`/issuer/companies/${company_id}/team_members/${team_member_id}`, values);
}

function deleteTeamMember({company_id, team_member_id}) {
  return axiosClient.delete(`/issuer/companies/${company_id}/team_members/${team_member_id}`);
}

const useAffiliationsList = ({company_id}) => {
  return useQuery(
    ["company-affilations-list", company_id],
    () => {
      return axiosClient
        .get(`/issuer/companies/${company_id}/affiliations`);
    }
  );
}

const createAffiliation = ({company_id, values}) => {
  return axiosClient.post(`/issuer/companies/${company_id}/affiliations/`, values);
}

const updateAffiliation = ({company_id, affiliation_id, values}) => {
  return axiosClient.put(`/issuer/companies/${company_id}/affiliations/${affiliation_id}`, values);
}

const deleteAffiliation = ({company_id, affiliation_id}) => {
  return axiosClient.delete(`/issuer/companies/${company_id}/affiliations/${affiliation_id}`);
}

const approveAffiliation = ({company_id, affiliation_id}) => {
  return axiosClient.put(`/issuer/companies/${company_id}/affiliations/${affiliation_id}/approve`);
}

const useCompanyAccountsList = ({company_id, page=1, per_page=10}) => {
  return useQuery(
    ['company-accounts-list', company_id, page],
    () => {
      return axiosClient
        .get(`issuer/companies/${company_id}/accounts`, {params: {page, per_page}})
    }, {
      keepPreviousData: true,
    }
  );  
}

const useCompanyAccountsInvitesList = ({company_id, page=1, per_page=10}) => {
  return useQuery(
    ['company-accounts-invites-list', company_id, page], 
    () => {
      return axiosClient
        .get(`issuer/companies/${company_id}/account_invites`, {params: {page, per_page}})
    }, {
      keepPreviousData: true,
    }
  );  
}

export {
  useCompaniesList,
  useCompany,
  updateCompany,

  useTeamMembersList,
  createTeamMember,
  updateTeamMember,
  deleteTeamMember,

  useAffiliationsList,
  createAffiliation,
  updateAffiliation,
  deleteAffiliation,
  approveAffiliation,

  useCompanyAccountsList,
  useCompanyAccountsInvitesList
}